// Held sales ("Hold Sale" / "Held" in the Android register). A held sale is a pre-payment cart
// parked so the cashier can start another order and resume it later. Stored locally per browser +
// merchant (localStorage). NOTE: Android holds server-side (saveOrderHoldPOS) so any register in the
// store can resume; the web v1 is local-only — cross-device server hold is a documented follow-up.

import { auth } from "./api";

const KEY = (mid) => `qv_web_register_held_${mid || ""}`;
const MAX = 50;

// Serializable cart fields that make up a held sale (payments are never held).
const SNAP_FIELDS = [
  "lines",
  "bogoList",
  "orderPercentDiscount",
  "orderAmountDiscount",
  "couponTotal",
  "customTotal",
  "coupon",
  "orderDiscounts", // the stacked discount lines (Android isSplitPaymentDiscount rows)
  "orderCouponModel", // Android mOrderDiscount — without it a restored % line stops re-evaluating on cart changes
  "isOutdoor",
  "outDoorPrice",
  "customer",
  "giftCards",
  "loyaltyAmount",
  "loyaltyPointsSpent",
  "storeCreditAmount",
];

export function snapshotCart(cart) {
  const snap = {};
  for (const k of SNAP_FIELDS) snap[k] = cart[k];
  return JSON.parse(JSON.stringify(snap)); // deep, plain
}

export function getHeldOrders() {
  try {
    const raw = localStorage.getItem(KEY(auth().merchantId));
    const list = raw ? JSON.parse(raw) : [];
    return Array.isArray(list) ? list : [];
  } catch {
    return [];
  }
}

function persist(list) {
  try {
    localStorage.setItem(KEY(auth().merchantId), JSON.stringify(list.slice(0, MAX)));
  } catch {
    /* quota / disabled — non-fatal */
  }
}

// order: { id, name, at, itemCount, total, snapshot }
export function addHeldOrder(order) {
  const list = getHeldOrders();
  list.unshift(order);
  persist(list);
}

export function removeHeldOrder(id) {
  persist(getHeldOrders().filter((o) => o.id !== id));
}
